<template>
  <WorkQuestionDialog
    ref="warningDialog"
    :message="message"
  >
    <template #header>
      {{ title }}
    </template>
    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <w-btn
        v-if="showClose"
        :outlined="showResolve"
        @click="close"
      >
        {{ closeLabel }}
      </w-btn>
      <w-btn
        v-if="showReject"
        :outlined="showResolve"
        @click="triggerReject"
      >
        {{ rejectLabel }}
      </w-btn>
      <w-btn
        v-if="showResolve"
        @click="triggerResolve"
      >
        {{ resolveLabel }}
      </w-btn>
    </template>
  </WorkQuestionDialog>
</template>

<script>
import WorkQuestionDialog from '@/components/base_components/dialog/icon-dialogs/WorkQuestionDialog';
import i18n from '@/language/i18n';

const DEFAULT_CLOSE_LABEL = i18n.t('Dialogs.BasicDialog.abort');
const DEFAULT_REJECT_LABEL = i18n.t('Dialogs.BeforeLeaveDialog.abort');
const DEFAULT_RESOLVE_LABEL = i18n.t('Dialogs.ConfirmationDialog.confirm');
const DEFAULT_TITLE = i18n.t('Dialogs.QuestionDialog.title');

export default {
  name: "WorkGlobalQuestionDialog",
  components: { WorkQuestionDialog },
  data() {
    return {
      message: "",
      title: DEFAULT_TITLE,
      closeLabel: DEFAULT_CLOSE_LABEL,
      resolveLabel: DEFAULT_RESOLVE_LABEL,
      rejectLabel: DEFAULT_REJECT_LABEL,
      showResolve: true,
      showReject: false,
      showClose: true,
    }
  },
  methods: {
    async open({
      message,
      title = DEFAULT_TITLE,
      closeLabel = DEFAULT_CLOSE_LABEL,
      resolveLabel = DEFAULT_RESOLVE_LABEL,
      rejectLabel = DEFAULT_REJECT_LABEL,
      showResolve = true,
      showClose = true,
      showReject = false
    }) {
      this.message = message;
      this.title = title;
      this.closeLabel = closeLabel;
      this.rejectLabel = rejectLabel;
      this.resolveLabel = resolveLabel;
      this.showReject = showReject;
      this.showResolve = showResolve;
      this.showClose = showClose;

      await this.$refs.warningDialog.open();
    }
  }
}
</script>
